import {isEqual, debounce} from "lodash";
import {updateCheckoutData as updateStoreData} from './checkout/thunks';

const selectCheckout = state => state.checkout;

let previousData = {
    email: '',
    billingAddress: {},
}
export const updateCheckoutData = store => debounce(() => {
    const {customer: {billingAddress, email}, cart} = selectCheckout(store.getState());
    let isDirty = false;
    const currentData = {
        email,
        billingAddress
    }

    if (cart && !isEqual(currentData.billingAddress, previousData.billingAddress)) {
        isDirty = true;
    }

    if (isDirty) {
        store.dispatch(updateStoreData({
            email,
            billingAddress
        }));
    }

    previousData = currentData;
}, 1000)